import apiClient from '../../apis/apiClient'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

// TODO: Replace types with the actual types from the API response when available.
export interface GetSearchResultsRequestDTO {
    grades?: string[]
    types?: string[]
    subjects?: string[]
    created_by?: string[]
    rating?: string
    sort?: string
    query?: string
    unrated?: string
}

export interface GetSearchResultsResponseDTO {
    message: string
    documents: any
    category: string | null
}

@Module({
    name: 'BrowseModule',
    namespaced: true,
})
export default class BrowseModule extends VuexModule {
    private _isLoading: boolean = false

    private _searchTerm: string = ''

    private _subjectFilters: string[] = []
    private _gradeFilters: string[] = []
    private _activityFilters: string[] = []
    private _ratingFilter: number = 3
    private _createdByFilters: string[] = []
    private _unrated: boolean = true
    private _sortBy: string = 'rating'

    private _recentSearches: string[] = []
    private _activeDoc: number | undefined = undefined

    get isLoading() {
        return this._isLoading
    }

    get searchTerm() {
        return this._searchTerm
    }

    get subjectFilters() {
        return this._subjectFilters
    }

    get gradeFilters() {
        return this._gradeFilters
    }

    get activityFilters() {
        return this._activityFilters
    }

    get ratingFilter() {
        return this._ratingFilter
    }

    get createdByFilters() {
        return this._createdByFilters
    }

    get unrated() {
        return this._unrated
    }

    get sortBy() {
        return this._sortBy
    }

    get recentSearches() {
        return this._recentSearches
    }

    get activeDoc() {
        return this._activeDoc
    }

    @Mutation
    setIsLoading(loading: boolean) {
        this._isLoading = loading
    }

    @Mutation
    setSearchTerm(searchTerm: string) {
        this._searchTerm = searchTerm
    }

    @Mutation
    setSubjectFilters(filters: string[]) {
        this._subjectFilters = filters
    }

    @Mutation
    setGradeFilters(filters: string[]) {
        this._gradeFilters = filters
    }

    @Mutation
    setActivityFilters(filters: string[]) {
        this._activityFilters = filters
    }

    @Mutation
    setRatingFilter(rating: number) {
        this._ratingFilter = rating
    }

    @Mutation
    setCreatedByFilters(filters: string[]) {
        this._createdByFilters = filters
    }

    @Mutation
    setUnrated(unrated: boolean) {
        this._unrated = unrated
    }

    @Mutation
    setSortBy(sortBy: string) {
        this._sortBy = sortBy
    }

    @Mutation
    setRecentSearches(searches: string[]) {
        this._recentSearches = searches
    }

    @Mutation
    setActiveDoc(docId?: number) {
        this._activeDoc = docId
    }

    @Action
    async getSearchResults(payload: GetSearchResultsRequestDTO): Promise<GetSearchResultsResponseDTO> {
        try {
            this.setIsLoading(true)

            return await apiClient.get('/search', {
                params: payload,
            })
        } catch (error) {
            console.error('Error in search action:', error)
            throw error
        } finally {
            this.setIsLoading(false)
        }
    }

    @Action
    async getNextBrowsePage({
        nextPageUrl,
        payload,
    }: {
        nextPageUrl: string
        payload: GetSearchResultsRequestDTO
    }): Promise<GetSearchResultsResponseDTO> {
        try {
            return await apiClient.get(nextPageUrl, {
                params: payload,
            })
        } catch (error) {
            console.error('Error in getNextBrowsePage action:', error)
            throw error
        }
    }

    @Action
    async getRecentSearches() {
        try {
            const response = await apiClient.get('/search/recent')

            this.setRecentSearches(response.data)
        } catch (error) {
            console.error('Error in getRecentSearches action:', error)
            throw error
        }
    }
}
